import { schema } from 'normalizr';

export const commentSchema = new schema.Entity('comment');
